import { connect } from 'react-redux';

import { calculateSavings } from '../actions';
import CalculatorPage from '../components/CalculatorPage';

export const mapStateToProps = state => ({
  annualAmountSavings: state.calculator.annualAmountSavings,
});

export const mapDispatchToProps = dispatch => ({
  onSubmit: calculatorForm => {
    dispatch(calculateSavings(calculatorForm));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalculatorPage);
